var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArtwork = function SvgArtwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 4.995C1 3.893 1.897 3 3 3h18c1.104 0 2 .893 2 1.995v14.01A1.998 1.998 0 0 1 21 21H3c-1.104 0-2-.893-2-1.995V4.995Zm2 14.01L21 19V4.995L3 5v14.005Zm5.028-9.602c.246-.495.687-.517.98-.056l1.698 2.68a1.01 1.01 0 0 0 1.386.31l.989-.615a1.078 1.078 0 0 1 1.433.286l2.264 3.177c.322.45.133.815-.419.815H5.741c-.552 0-.8-.403-.554-.896l2.84-5.701ZM17.5 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
  })));
};

export default SvgArtwork;